// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_hq-7";
export var emphasizeQuantity = "_hq-3";
export var flatBottomCorners = "_hq-5";
export var productImage = "_hq-0";
export var quantityContainer = "_hq-2";
export var quantityHeader = "_hq-6";
export var tooltip = "_hq-1";
export var wrapAndEllipsesOverflow = "_hq-4";